import { StaffMember } from '@/shared/domain/StaffMember';
import { StaffMemberRepository } from '@/shared/domain/StaffMemberRepository';

export class StaffMemberMemory implements StaffMemberRepository {

  public async getStaffMembers (): Promise<Array<StaffMember>> {
    return [
      {
        id: 1,
        username: 'john.hansen',
        name: 'John Hansen',
        role: 'CEO',
        avatar: '/assets/img/staff/john_hansen.webp',
        bio: `<p class="pb-3">John Hansen has been in the health insurance industry since 2004. He brings a wealth of knowledge to Health for California. He oversees marketing, web development, and web content. John has been the top selling broker of individual plans in California for the last decade.</p>
              <p class="pb-3">He is married with four daughters, and enjoys coaching middle school volleyball and basketball. Formerly, he has been a pastor and a public school teacher.</p>
              <p>John loves making things simple and easy to understand.</p>`,
      },
      {
        id: 2,
        username: 'jacob.hansen',
        name: 'Jacob Hansen',
        role: 'Vice President of Medicare and Small Business Sales',
        avatar: '/assets/img/staff/jacob_hansen.webp',
        bio: `<p class="pb-3">Jacob was born into the insurance industry. His father Bill started an insurance agency in 1987 and a few years after crawling on the floor and playing with the "rollie chairs" Jacob started helping in the office at 14 years old. After earning a Bachelor of Arts degree in Economics from University of California, Davis, Jacob got licensed for all four types of insurance. He then quickly became the office manager for Bill's Farmers Insurance Agency.</p>
              <p>In 2014 with the implementation of the Affordable Care Act, he got Certified with Covered California to assist clients with their Health Insurance needs. Health Insurance quickly became the largest section of his book of business and the primary focus of his business. After three years of focusing on Health Insurance through the California Exchange, Jacob realized that many of his clients needed help with their transition to Medicare at age 65. As he researched Medicare Options, Jacob was astounded by the complicated nature of Senior Health Insurance. This became Jacob's focus and specialty. He now teaches webinars multiple times a week helping seniors better understand the Medicare System and their options.</p>`,
      },
      {
        id: 3,
        username: 'stephen.saucier',
        name: 'Stephen Saucier',
        role: 'Director of Individual and Family Sales',
        avatar: '/assets/img/staff/stephen_saucier.webp',
        bio: `<p class="pb-3">Stephen Saucier is the Director of Individual and Family Sales at Health For California Insurance Center. With over a decade of experience in the health insurance industry, he has been instrumental in helping individuals and families navigate their coverage options. Since joining Health For CA in 2013 and stepping into his leadership role in 2017, Stephen has played a key role in driving growth and customer-focused solutions.</p>
              <p>Beyond his professional work, Stephen has been happily married for over 20 years and is a proud father of three. When he's not helping clients or leading his team, he enjoys spending quality time with his family and making lasting memories.</p>`,
      },
      {
        id: 4,
        username: 'wendy.barnett',
        name: 'Wendy Barnett',
        role: 'Health Insurance Agent',
        avatar: '/assets/img/staff/wendy_barnett.webp',
        bio: '<p>Wendy Barnett has been helping Californians on the individual market obtain their health insurance since 2013. Her focus is on excellent customer service. She strives to educate customers so that they can make informed decisions that best meet their insurance needs. </p>',
      },
      {
        id: 5,
        username: 'esmeralda.mercado',
        name: 'Esmeralda Mercado',
        role: 'Health Insurance Agent',
        avatar: '/assets/img/staff/esmeralda_mercado.webp',
        bio: '<p>Esmeralda Mercado has been a health insurance agent for the past 13 years. Previously, she worked in the insurance industry as a Commercial Line Producer\'s Assistant, and Personal Lines Underwriter. She has written a few articles focused on helping consumers better understand their health plan options.</p>',
      },
    ];
  }

}
